import {
  LoanRequestStateTypes,
  LoanRequestActionTypes,
} from "./LoanRequest.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: LoanRequestStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const LoanRequestReducer = (
  state: LoanRequestStateTypes = INITIAL_STATE,
  action: any
): LoanRequestStateTypes => {
  switch (action.type) {
    case LoanRequestActionTypes.FETCH_ALL_LOAN_REQUEST:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case LoanRequestActionTypes.FETCH_ALL_LOAN_REQUEST_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case LoanRequestActionTypes.FETCH_ALL_LOAN_REQUEST_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case LoanRequestActionTypes.FETCH_ALL_LOAN_REQUEST_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case LoanRequestActionTypes.FETCH_ONE_LOAN_REQUEST:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case LoanRequestActionTypes.FETCH_ONE_LOAN_REQUEST_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case LoanRequestActionTypes.FETCH_ONE_LOAN_REQUEST_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case LoanRequestActionTypes.FETCH_ONE_LOAN_REQUEST_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default LoanRequestReducer;
